import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { useInstance } from 'intact-vue-next';
export function useLoad(getField) {
  var instance = useInstance();
  function loadData(_x) {
    return _loadData.apply(this, arguments);
  }
  function _loadData() {
    _loadData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var _instance$get, loadData, children;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _instance$get = instance.get(), loadData = _instance$get.loadData;
            if (loadData) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            children = getField(item, 'children');
            if (!(children && !children.length && !item.loaded)) {
              _context.next = 9;
              break;
            }
            _context.next = 7;
            return loadData(item);
          case 7:
            item.loaded = true;
            instance.forceUpdate();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _loadData.apply(this, arguments);
  }
  return loadData;
}